import React from "react";
import { FieldArray } from "formik";
import { SectionToggleState, useFieldValue, useSectionHelper } from "hooks";
import { FinanceSubModalSection } from "constants/settings";
import { CollapseHeader, FormCollapse } from "components/Form";
import { withNamespace } from "components/Form/FormikControls";
import { Grid } from "@material-ui/core";
import { SlimButton } from "components/Button";
import { ButtonIcon } from "components/Button/FontAwesomeButton";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { Paper } from "components/Paper";
import AuditLogLink from "components/AuditLog/AuditLogLink";
import { AuditLogTypes } from "constants/auditLog";
import { BankingDetailsForm } from "components/Form/Fields/BankingDetailsForm";

interface PaymentBankingDetailsProps {
  sectionHelper: SectionToggleState;
  namespace: string;
}

export const BankingDetails: React.FC = ({
  sectionHelper,
  namespace: ns,
}: PaymentBankingDetailsProps) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.PAYMENT_BANKING_DETAILS,
  );

  const paymentBankingDetails = useFieldValue(
    withNamespace(ns, "paymentBankingDetails"),
  );
  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={<CollapseHeader title="Banking Details" />}
    >
      <FieldArray name={withNamespace(ns, "paymentBankingDetails")}>
        {arrayHelpers => {
          const addNew = () => {
            arrayHelpers.push({
              bankingDetails: { accountName: "", accountNumber: "", bsb: "" },
              saleFilters: [],
              isDefault: false,
            });
          };

          return (
            <Grid container spacing={2}>
              {paymentBankingDetails.map(
                (paymentBankingDetail: BankingDetails, idx) => (
                  <Grid item xs={12} key={paymentBankingDetail.id || idx}>
                    <Paper>
                      <AuditLogLink
                        auditLogType={AuditLogTypes.BANKING_DETAIL}
                        dataId={paymentBankingDetail.id}
                        returnTo={window.location.hash}
                      />
                      <Grid item xs={12} spacing={2} container>
                        <BankingDetailsForm
                          namespace={`billingSettings.paymentBankingDetails.${idx}`}
                          includeHobbyFarmer={false}
                        />
                      </Grid>
                    </Paper>
                  </Grid>
                ),
              )}

              <Grid item xs={12}>
                <SlimButton onClick={addNew} type="button">
                  <ButtonIcon icon={faPlus} />
                  &nbsp;New Payment Details
                </SlimButton>
              </Grid>
            </Grid>
          );
        }}
      </FieldArray>
    </FormCollapse>
  );
};
